import _ from 'lodash';
import Service from './abstract';

const defaultTax = {
    with: 'tax,tax_category'
};

class Tax extends Service {
    constructor () {
        super('taxes');
    }

    getTax (options = {}) {
        const opts = {
            url: `${this.basePath}/aliquots`,
            qs: _.defaultsDeep({}, options, defaultTax)
        };

        return this.get(opts);
    }
}

export default new Tax();
